import { CloseButton, Group, Stack } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { AgentBuilder } from "./agent/CreateAgent";
const AgentPageCreate = ({ is_ai }) => {
  const lang = useLanguage((s) => s.language);
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(`/agents/`);
  }, [navigate]);

  const onCreate = useCallback(
    (newItem) => {
      navigate(`/agents/`);
    },
    [navigate],
  );

  return (
    <Stack mx={"auto"} gap={"xs"}>
      <AgentBuilder onFinish={onCreate} />
    </Stack>
  );
};

export default AgentPageCreate;
